<template>
  <v-container v-if="!review">
    <v-window v-model="step">
      <v-window-item>
        <div class="text-h4">IP Requests</div>
        <p>Please fill out multiple entries if you are requesting multiple blocks of IPs</p>
        <v-container>
          <v-row
            v-for="(request, i) in product.ip_request"
            :key="i"
          >
            <v-col>
              <v-text-field
                v-model="product.ip_quantity[i]"
                label="Number of IP addresses requested"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="product.ip_descrip[i]"
                label="Description of devices using IP addresses"
              ></v-text-field>
            </v-col>
            <v-col cols="auto">
              <v-btn
                color="error"
                text
                @click="deleteRequest(i)"
              >Delete</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-btn
                color="third"
                class="white--text"
                @click="addRequest"
              >
                Add Additional IP Justification details
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <a
                href="#"
                @click="displayTable('subnets')"
              >
                Subnet Cheatsheat
              </a>
            </v-col>
            <v-col cols="auto">
              <a
                href="#"
                @click="displayTable('pricing')"
              >
                IP Pricing
              </a>
            </v-col>
          </v-row>
        </v-container>
      </v-window-item>
      <v-window-item>
        <div class="text-h4">Do you have an ARIN.net account?</div>
        <v-radio-group v-model="product.arin">
          <v-radio label="Yes" value="y"></v-radio>
          <v-radio label="No" value="n"></v-radio>
        </v-radio-group>
      </v-window-item>
      <v-window-item v-if="product.arin === 'y'">
        <div class="text-h4">Provide your ARIN.net account details</div>
        <v-text-field
          label="ARIN OrgId"
          v-model="product.arin_id"
        ></v-text-field>
        <v-text-field
          label="ARIN AS"
          v-model="product.arin_as"
        ></v-text-field>
      </v-window-item>
      <v-window-item v-if="product.arin === 'n'">
        <div class="text-h4">Please provide a contact to use for an ARIN.net account</div>
        <v-text-field
          v-model="product.ipj_company_name"
          label="Company Name"
        ></v-text-field>

        <Contact
          :d="contactData"
          @assignContact="assignContact"
        />
      </v-window-item>
    </v-window>
    <v-dialog
      v-model="showTable"
    >
      <v-card>
        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    v-for="header in headers"
                    :key="header.id"
                    class="text-left"
                  >{{ header.text }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, i) in items" :key="i">
                  <td v-for="field in headers" :key="item[field.id]">{{ item[field.id] }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
  <div v-else>
    <div>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">IPs Requested</th>
              <th class="text-left">Description</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(request, i) in product.ip_request" :key="i">
              <td>{{ product.ip_quantity[i] }}</td>
              <td>
                {{ product.ip_descrip[i] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
    <ReviewItem
      label="Do you have an ARIN.net account?"
      :value="product.arin === 'y' ? 'Yes' : 'No'"
    />
    <div v-if="product.arin ==='y'">
      <ReviewItem
        label="What is your ARIN.net OrgId?"
        :value="product.arin_id"
      />
      <ReviewItem
        label="What is your ARIN.net AS?"
        :value="product.arin_as"
      />
    </div>
    <div v-if="product.arin === 'n'">
      <ReviewItem
        label="ARIN Company Name:"
        :value="product.ipj_company_name"
      />
      <ReviewItem
        label="ARIN Contact:"
        :value="product.ipj_contact_name"
      />
      <ReviewItem
        label="ARIN Contact Phone:"
        :value="product.ipj_contact_phone"
      />
      <ReviewItem
        label="ARIN Contact Email:"
        :value="product.ipj_contact_email"
      />
    </div>
  </div>
</template>

<script>
/* eslint object-curly-newline: "off", operator-linebreak: "off" */
import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import ReviewItem from '@/components/ReviewItem.vue';
import Contact from '@/components/formfields/Contact.vue';

export default {
  name: 'IpjForm',
  props: {
    review: {
      required: false,
      type: Boolean,
    },
  },
  mounted() {
    const vm = this;
    vm.product = _.cloneDeep(vm.getProductInfo());
    const somethingIsNull = vm.product.ip_request == null
      || vm.product.ip_quantity == null
      || vm.product.ip_descrip == null;
    let lengthDiffers = false;
    if (!somethingIsNull) {
      lengthDiffers = !(
        vm.product.ip_request.length === vm.product.ip_quantity.length
          &&
        vm.product.ip_request.length === vm.product.ip_descrip.length);
    }
    if (somethingIsNull || lengthDiffers) {
      vm.$set(vm.product, 'ip_request', ['new']);
      vm.$set(vm.product, 'ip_quantity', []);
      vm.$set(vm.product, 'ip_descrip', []);
    }
    if (!vm.product.ipj_company_name) {
      vm.product.ipj_company_name = vm.getQuoteFacts.company_name;
    }
    if (!vm.review) {
      vm.hijackStepper((goRight) => {
        vm.sync();
        if ((vm.step === 0 && !goRight) || (vm.step === 2 && goRight)) {
          vm.unHijackStepper();
          vm.nextSubTab(goRight);
        }
        vm.step += (goRight ? 1 : -1);
      });
    }
  },
  beforeDestroy() {
    this.unHijackStepper();
  },
  methods: {
    ...mapActions(['syncFormData', 'hijackStepper', 'unHijackStepper', 'nextSubTab']),
    deleteRequest(i) {
      this.product.ip_request.splice(i, 1);
      this.product.ip_quantity.splice(i, 1);
      this.product.ip_descrip.splice(i, 1);
    },
    addRequest() {
      this.product.ip_request.push('new');
      this.product.ip_quantity.push(null);
      this.product.ip_descrip.push(null);
    },
    sync() {
      this.syncFormData({
        mainKey: this.getProductIdSelected,
        data: _.cloneDeep(this.product),
      });
    },
    displayTable(type) {
      this.tableType = type;
      this.showTable = true;
    },
    assignContact(e) {
      this.$set(this.product, 'ipj_contact_name', e.fullname);
      this.$set(this.product, 'ipj_contact_phone', e.phone);
      this.$set(this.product, 'ipj_contact_email', e.email);
    },
  },
  data() {
    return {
      product: {},
      step: 0,
      showTable: false,
      tableType: null,
      subnets: {
        headers: [
          { id: 'subnet', text: 'Subnet' },
          { id: 'cidr', text: 'Length' },
          { id: 'max_ips', text: 'Max IPs' },
          { id: 'example', text: 'IP Example' },
        ],
        items: [
          { subnet: '255.255.255.255', cidr: '/32', max_ips: '1 (None Usable)', example: '192.168.0.1' },
          { subnet: '255.255.255.252', cidr: '/30', max_ips: '4 (1 Usable)', example: '192.168.0.0-192.168.0.3' },
          { subnet: '255.255.255.248', cidr: '/29', max_ips: '8 (5 Usable)', example: '192.168.0.0-192.168.0.7' },
          { subnet: '255.255.255.240', cidr: '/28', max_ips: '16 (13 Usable)', example: '192.168.0.0-192.168.0.15' },
          { subnet: '255.255.255.224', cidr: '/27', max_ips: '32 (29 Usable)', example: '192.168.0.0-192.168.0.31' },
          { subnet: '255.255.255.192', cidr: '/26', max_ips: '64 (61 Usable)', example: '192.168.0.0-192.168.0.63' },
          { subnet: '255.255.255.128', cidr: '/25', max_ips: '128 (125 Usable)', example: '192.168.0.0-192.168.0.127' },
          { subnet: '255.255.255.0', cidr: '/24', max_ips: '256 (253 Usable)', example: '192.168.0.0-192.168.0.255' },
          { subnet: '255.255.254.0', cidr: '/23', max_ips: '512 (509 Usable)', example: '192.168.0.0-192.168.1.255' },
          { subnet: '255.255.252.0', cidr: '/22', max_ips: '1024 (1021 Usable)', example: '192.168.0.0-192.168.3.255' },
          { subnet: '255.255.248.0', cidr: '/21', max_ips: '2048 (2045 Usable)', example: '192.168.0.0-192.168.7.255' },
        ],
      },
      pricing: {
        headers: [
          { id: 'length', text: 'Length' },
          { id: 'amount', text: 'Usable IPs' },
          { id: 'mrc', text: 'Monthly Recurring Charge' },
        ],
        items: [
          { length: '/30', amount: '1', mrc: 'No Charge' },
          { length: '/29', amount: '5', mrc: '$10.00' },
          { length: '/28', amount: '13', mrc: '$20.00' },
          { length: '/27', amount: '29', mrc: '$40.00' },
          { length: '/26', amount: '61', mrc: '$80.00' },
          { length: '/25', amount: '125', mrc: '$160.00' },
          { length: '/24', amount: '253', mrc: '$300.00' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['getProductIdSelected', 'getProductInfo', 'getQuoteFacts']),
    numPages() {
      if (this.product.arin === "n") {
        return 2;
      }
      return 3;
    },
    headers() {
      return this[this.tableType].headers;
    },
    items() {
      return this[this.tableType].items;
    },
    contactData() {
      return {
        fullname: this.product.ipj_contact_name,
      };
    },
  },
  watch: {
    product: {
      deep: true,
      handler() {
        this.sync();
      },
    },
  },
  components: {
    ReviewItem,
    Contact,
  },
};
</script>
